<template>
  <div id="default-header">
    <nav
      :class="['navbar is-fixed-top', { 'is-active': showMenu }]"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <router-link class="navbar-item hellopeter-logo" to="/">
          <router-link
            tag="img"
            to="/"
            src="/static/img/hp-social-int-logo.svg"
            alt="HP Logo"
            width="121"
            height="30"
          />
        </router-link>
        <button
          @click.prevent="showMenu = !showMenu"
          :class="['navbar-burger', { 'is-active': showMenu }]"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <div :class="['navbar-menu', { 'is-active': showMenu }]">
        <div class="navbar-end top-header">
          <router-link class="navbar-item" to="/industries">INDUSTRIES</router-link>

          <BulmaAccordion
            class="best-industries-accordion is-hidden-tablet"
            :dropdown="false"
            :icon="'caret'"
            :caretAnimation="{
                    duration: '.2s',
                    timerFunc: 'ease-in-out',
                  }"
            :slide="{
                    duration: '.2s',
                    timerFunc: 'ease',
                  }"
          >
            <BulmaAccordionItem>
              <h4 slot="title">BEST BUSINESSES</h4>
              <p slot="content">
                <a
                  v-for="(category,index) in categories"
                  :key="index"
                  @click.prevent="getBestBiz(category.slug)"
                  v-text="category.name"
                ></a>
              </p>
            </BulmaAccordionItem>
          </BulmaAccordion>

          <div class="navbar-item has-dropdown is-hoverable is-hidden-mobile">
            <a class="navbar-link is-arrowless">BEST BUSINESSES</a>
            <div class="best-industries-navigation-outer">
              <div class="navbar-dropdown best-industries-navigation" id="best-business">
                <ul>
                  <li v-for="(category,index) in categories" :key="index">
                    <a
                      class="navbar-item"
                      v-text="category.name"
                      @click.prevent="getBestBiz(category.slug)"
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <a class="navbar-item" :href="blog_url" rel="nofollow">BLOG</a>
          <a
            v-if="isLoggedIn"
            href="javascript:void(0);"
            class="navbar-item is-hidden-desktop"
            @click="myProfilePath"
          >MY PROFILE AND REVIEWS</a>
          <a
            v-if="isLoggedIn"
            class="navbar-item is-hidden-desktop"
            @click.prevent="logout"
            href="#"
          >SIGN OUT</a>
          <div class="navbar-item">
            <div class="buttons">
              <router-link class="button" to="/write-a-review">WRITE A REVIEW</router-link>
              <a class="button is-outlined" :href="portal_url" rel="nofollow">FOR BUSINESS</a>
              <a
                @click.prevent="showSearch = !showSearch"
                :class="['button search-button is-hidden-mobile is-hidden-tablet-only', { 'search-active' : showSearch }]"
              >
                <span class="icon">
                  <i class="fas fa-search"></i>
                </span>
              </a>
            </div>
          </div>
          <div
            v-if="isLoggedIn"
            class="navbar-item has-dropdown is-hidden-touch"
            @click="dropdownIsActive=!dropdownIsActive"
          >
            <a class="navbar-link" href="#">Hello,&nbsp;{{ getFullName }}</a>
            <div class="navbar-dropdown is-right" :class="{'dropdown-Isactive': dropdownIsActive }">
              <a
                class="navbar-item"
                href="javascript:void(0);"
                @click="myProfilePath"
              >My profile and reviews</a>
              <hr class="dropdown-divider" />
              <a @click.prevent="logout" class="navbar-item">Sign out</a>
            </div>
          </div>
          <router-link v-if="!isLoggedIn" class="navbar-item" to="/login">SIGN IN</router-link>
          <router-link v-if="!isLoggedIn" class="navbar-item" to="/register">JOIN</router-link>
        </div>
      </div>
    </nav>

    <div id="floating-write-review" class="is-hidden-desktop">
      <a
        @click.prevent="showSearch = !showSearch"
        :class="['button search-button', { 'search-active' : showSearch }]"
      >
        <span class="icon">
          <i class="fas fa-search"></i>
        </span>
      </a>
      <router-link to="write-a-review">Write a review</router-link>
    </div>
    <div v-if="showSearch" class="search-columns">
      <div class="search-columns-inner">
        <div class="field has-addons">
          <div class="control">
            <input style="display:none;" type="text" />
            <input
              autocomplete="off"
              @keyup.enter="forwardSearch(searchString)"
              :value="searchString"
              @input="searchString=$event.target.value"
              @keyup="orgLookup()"
              class="input"
              type="text"
              placeholder="Search for businesses..."
            />
            <!-- orgs lookup dropdown -->
            <div :class="['dropdown', showOrgLookDropdown]" v-show="orgsFound">
              <div class="dropdown-menu" role="menu">
                <div
                  class="dropdown-content is-paddingless"
                  @mouseleave.self="hideBusinessAutoComplete"
                >
                  <a
                    v-for="(business,index) in businesses"
                    :key="index"
                    @click.prevent="selectOrg(business)"
                    href="#"
                    :ref="`${business.id}`"
                    class="dropdown-item has-text-left"
                    v-html="business.name"
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div class="control">
            <a @click.prevent="forwardSearch(searchString)" class="button">SEARCH</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import auth from "@/mixins/auth.js";
import search from "@/mixins/search.js";
import ApiResource from "@/api/ApiResource.js";
import axios from "axios";
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";

export default {
  name: "DefaultHeader",
  components: {
    BulmaAccordion,
    BulmaAccordionItem
  },
  mixins: [auth, search],

  data() {
    return {
      showMenu: false,
      dropdownIsActive: false,
      blog_url: process.env.BLOG_URL,
      portal_url: process.env.PORTAL_URL,
      showSearch: false,
      searchString: "",
      userDetails: null,
      org_selected: false,
      show_dropdown: false,
      on_blur_close: false,
      is_loading: false,
      drop_down_opened: false,
      businesses: [],
      business_available: false,
      categories: []
    };
  },
  created() {
    window.events.$on("searchResultsLanded", () => {
      this.showSearch = false;
    });
    window.events.$on("mobileNavMenuSelected", () => {
      this.showMenu = false;
    });
    this.getCategories();
  },
  computed: {
    getFullName() {
      const hasDisplayName = !!localStorage.getItem("displayName");
      if (hasDisplayName) {
        return localStorage.getItem("displayName");
      }
      return "";
    },

    orgsFound() {
      return this.businesses.length > 0;
    },
    showOrgLookDropdown() {
      if (this.on_blur_close && !this.org_selected) {
        return "";
      }
      if (
        (this.org_selected || this.businesses.length > 0) &&
        !this.on_blur_close
      ) {
        return "is-active";
      }
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownIsActive = false;
    },
    myProfilePath() {
      this.dropdownIsActive = true;
      const hasProfileId = !!localStorage.getItem("profile_id");
      if (hasProfileId) {
        const profileId = localStorage.getItem("profile_id");
        this.$router.push(`/profile/${profileId}`);
      } else {
        this.$router.push("/");
      }
    },
    orgLookup() {
      this.org_selected = false;
      this.show_dropdown = false;
      this.on_blur_close = false;
      if (this.searchString.length < 3) {
        this.businesses = [];
        this.show_dropdown = false;
      }
      else {
        this.is_loading = true;
        let keyword = encodeURIComponent(this.searchString);
        new ApiResource({})
          .send(`/search/business?name=${keyword}`, {}, "get")
          .then(businesses => {
            if (businesses.length === 0) {
              this.businesses = [];
              this.org_selected = true;
              this.show_dropdown = false;
              this.drop_down_opened = false;
              this.is_loading = false;
            } else {
              this.drop_down_opened = true;
              this.businesses = businesses;
              this.is_loading = false;
            }
          })
          .catch(() => {
            this.is_loading = false;
            this.drop_down_opened = false;
          });
      }
    },
    hideBusinessAutoComplete() {
      try {
        this.drop_down_opened = true;
        this.on_blur_close = true;
        const parent = this;
        parent.business_available = false;
        this.businesses.forEach(business => {
          let inlist = false;
          if (
            this.searchString.toLowerCase() === business.name.toLowerCase() &&
            !inlist
          ) {
            if (business.status === "ACTIVE") {
              parent.business_available = false;
              parent.org_selected = true;
              parent.drop_down_opened = false;
            }
            else if (!inlist) {
              inlist = true;
              parent.org_selected = true;
              parent.business_available = true;
              parent.drop_down_opened = false;
            }
          }
          if (
            this.searchString.toLowerCase() !== business.name.toLowerCase() &&
            !inlist
          ) {
            parent.business_available = true;
            parent.drop_down_opened = false;
            parent.org_selected = true;
          }
        });
      } catch (e) {}
    },
    selectOrg(business) {
      this.org_selected = true
      this.businesses = []
      this.drop_down_opened = false
      this.searchString = ""
      this.showSearch = false
      this.$router.push(`/${business.slug}`)
      window.location.reload()
    },
    getCategories() {
      axios
        .get("/categories")
        .then(({ data }) => {
          this.categories = data
        })
        .catch(() => {
         flash('There was an error retreiving all of the Categories', 'is-warning')
        });
    },
    getBestBiz(slug){
      this.$router.push(`/best-businesses/${slug}`)
      window.events.$emit('best-biz')
      document.getElementById("best-business").blur()
    }
  }
};
</script>
<style scoped>
#default-header {
  width: 100%;
  height: 75px;
  margin: 0 auto;
  padding: 0;
  background-color: #ffffff;
  color: #58595b;
  position: fixed;
  top: 0;
  z-index: 30;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.navbar {
  min-height: 75px;
  width: 100%;
  max-width: 1125px;
  margin-left: auto;
  margin-right: auto;
}

.navbar-item {
  font-size: 0.85rem;
}

.button {
  border: 0;
  border-radius: 0;
  background-color: #30aae1;
  color: #ffffff;
  font-size: 0.85rem;
  padding: 1.3rem 2rem;
}

.button.is-outlined {
  background-color: #ffffff;
  color: #30aae1;
  border: 1px solid #30aae1;
}

.buttons .button:not(:last-child):not(.is-fullwidth) {
  margin-right: 1rem;
}

.navbar-brand {
  min-height: 75px;
}
.navbar-burger {
  border: 0;
  color: #2fabe1;
  min-height: 75px;
}

.navbar-burger,
.navbar-burger:hover {
  background-color: #ffffff;
}

a.navbar-item:hover {
  background-color: #ffffff;
  color: #30aae1;
}

#floating-write-review {
  position: absolute;
  right: 4rem;
  top: 1.5rem;
  z-index: 31;
}

#floating-write-review > a {
  text-decoration: underline;
  color: #4db7e5;
}

.navbar-menu > .navbar-end > .navbar-item {
  padding-right: 0;
}

.search-button,
.search-button:hover,
.search-button:visited {
  color: #58595b;
  background-color: transparent;
  border: none;
  padding: 1.3rem 0.5rem;
}

#floating-write-review > .search-button {
  padding: 0 2rem;
  text-decoration: none;
  font-size: 1.2rem;
  margin-top: -0.5rem;
  color: #58595b;
}

.search-active {
  color: #2eaae1 !important;
}

.search-columns {
  background-color: #f5f5f5;
  color: #8a8c91 !important;
  margin-top: 75px;
  border-top: 1px solid #c9c9c9;
  border-bottom: 1px solid #c9c9c9;
}

.search-columns-inner {
  width: 100%;
  max-width: 1125px;
  max-height: 54px;
  margin-left: auto;
  margin-right: auto;
}

.search-columns-inner .input {
  width: 100%;
  border-radius: 0;
  border: none;
  background-color: transparent;
  color: #8a8c91;
  box-shadow: none;
  padding: 1.7rem 3rem 1.7rem 1rem;
}

.search-columns-inner > .field > .control:first-child {
  width: 100%;
}

.search-columns-inner .button,
.search-columns-inner .button:hover,
.search-columns-inner .button:visited {
  background-color: #dddbdb;
  color: #58595b;
  padding: 1.7rem 3rem;
}

::placeholder {
  color: #8a8c91;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #8a8c91;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #8a8c91;
}

.dropdown-menu {
  padding-top: 0;
}
.navbar-dropdown.dropdown-Isactive.is-right {
  display: block !important;
}

.top-header a.navbar-item:focus, .top-header a.navbar-item:focus-within, .top-header a.navbar-item:hover, .top-header a.navbar-item.is-active, .top-header .navbar-link:focus, .top-header .navbar-link:focus-within, .top-header .navbar-link:hover, .top-header .navbar-link.is-active {
  background-color: white;
  color: #3273dc;
}
.best-industries-navigation {
  min-width: 650px;
  width: 100%;
}
.best-industries-navigation ul li {
  width: 33%;
  float: left;
}
.is-arrowless {
  padding-right: 0;
}
.is-arrowless :hover {
  color: #30aae1 !important;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .best-industries-navigation-outer{
    height: 270px;
    max-width: 100%;
  }
  .best-industries-navigation{
    width: 100%;
    min-width: 668px;
  }
  .best-industries-navigation ul{
    padding-left: 15px;
  }
  .best-industries-navigation ul li{
    width: 25%;
  }
  .best-industries-navigation ul li a {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .navbar-dropdown ul li:last-child{
    float: left;
  }
}
@media screen and (max-width: 767px) {

  .top-header .best-industries-accordion {
    color: #4a4a4a;
    line-height: 1.5;
    font-size: 0.85rem;
  }
  .top-header > .card-header, .top-header > .card {
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  .card-header
  {
     box-shadow: none;
    -webkit-box-shadow: none;
  }

  .best-industries-accordion > .card > .card-header {
     box-shadow: none !important;
    -webkit-box-shadow: none !important;
  }

  .best-industries-accordion > .card > .accordion-body {
    height: 200px !important;
    overflow-y: scroll !important;
  }

  .best-industries-accordion a {
    display: inherit;
  }
  .best-industries-navigation {
    min-width: 0;
  }

  #floating-write-review > .search-button {
    padding: 0 1rem;
  }
  .best-industries-navigation {
    height: 145px;
    overflow-y: scroll;
  }
  .best-industries-navigation ul li {
    width: 100%;
    float: inherit;
  }
}
.navbar-item a.navbar-link:hover {
  color: #3273dc;
}
  .hellopeter-logo {
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/DefaultHeader.vue